<template>
    <modal :show="show">
        <div slot="modalHeader">
          <modal-header :closeModal="close"><i class="fa fa-exclamation-triangle"></i>&nbsp; Accept Download Charge</modal-header>
        </div>
        <p>In requesting these files for download your account will be charged for <strong>{{ charges.totalDownloads }}</strong> new downloads.
        </p>
        <p v-if="charges.alreadyDownloaded > 0"><strong>{{ charges.alreadyDownloaded }}</strong> units have previously been charged for.</p>
        <a v-on:click="showAdvanced = !showAdvanced">Advanced options</a>
        <div id="advancedOptions" v-if="showAdvanced" >
          <hr/>
          <div class="form-group row">
            <label for="inputEmail3" class="col-sm-4 col-form-label">Naming Convention</label>
            <div class="col-sm-8">
              <select name="name_format" v-model="options.name_format">
                <option v-for="(value, key) in dropDownChoices" :key="key" :value="key" >{{ value }}</option>
              </select>
            </div>
          </div>
          <div v-if="creativeUnitType !== 'html-video'">
            <input type="checkbox" id="zip_creatives" v-model="options.zip_creatives">
            <label for="zip_creatives">Zip creatives. [Put each creative in its own zip file]</label>
          </div>
          <div v-if="creativeUnitType ==='html'">
            <input type="checkbox" id="statics" v-model="options.statics" @change="validateHtmlOptions($event)">
            <label for="statics">Statics [Include static versions of HTML units]</label>
          </div>
          <div v-if="creativeUnitType ==='html'">
            <input type="checkbox" id="include_html5" v-model="options.include_html5" @change="validateHtmlOptions($event)" :disabled="options.include_html5_inactive">
            <label for="include_html5">HTML5 [Include the HTML5 versions]</label>
          </div>
          <div v-if="creativeUnitType ==='psd'">
            <div>
              <input type="checkbox" id="group" v-model="options.group_by">
              <label for="group_by">Group by creative</label>
            </div>
          <fieldset class="form-group">
            <h4>Formats: </h4>
            <div>
              <input type="checkbox" id="psd" v-model="options.formats.psd">
              <label for="psd">PSD</label>
            </div>
            <div>
              <input type="checkbox" id="gif" v-model="options.formats.gif">
              <label for="gif">GIF</label>
            </div>
            <div>
              <input type="checkbox" id="jpg" v-model="options.formats.jpg">
              <label for="jpg">JPG</label>
            </div>
            <div>
              <input type="checkbox" id="png" v-model="options.formats.png">
              <label for="png">PNG</label>
            </div>
          </fieldset>
          </div>
        </div>
        <div slot="modalFooter">
          <modal-footer :closeModal="close" :confirm="confirm" cancelText="Cancel Download request" confirmText="Accept Charge and Download" confirmTheme="danger" />
        </div>
    </modal>
</template>

<script>
import Modal from '@/components/Modal/modal'
import ModalHeader from '@/components/Modal/modal-header'
import ModalFooter from '@/components/Modal/modal-footer'
import ButtonCta from '@/components/Button/button'
import {modalMixin} from '@/mixins/modalMixin'
import {creativeMixin} from '@/mixins/creativeMixin'
import {notificationMixin} from '@/mixins/notificationMixin'

export default {
  name: 'modal_charge_confirmation',
  mixins: [modalMixin, creativeMixin, notificationMixin],
  components: {
    Modal,
    ModalHeader,
    ModalFooter,
    ButtonCta
  },
  props: {
    show: Boolean,
    confirmId: String,
    charges: Object,
    creativeUnitType: String,
    tableColumns: Object
  },
  data: () => ({
    showAdvanced: false,
    options: {
      formats: {
        psd: false,
        gif: false,
        jpg: false,
        png: true
      },
      zip_creatives: true,
      statics: false,
      include_html5: true,
      include_html5_inactive: false,
      group_by: false,
      name_format: 'default'
    },
    choices: {}
  }),
  mounted () {},
  computed: {
    charge () {
      const value = this.charges.totalDownloads * this.charges.downloadCost
      return Math.max(0, value)
    },
    dropDownChoices () {
      // decalare default value,
      // Strip Blank, status, date_Created and all fields
      var tempChoices = {
        'default': 'Default [Master_Locale]', // ['$$master', '_', '$$locale']
        'master': 'Master only', // ['$$master']
        'locale': 'Locale only' // ['$$locale']
      }
      return tempChoices
    }
  },
  methods: {
    confirm () {
      // take options from form and convert to json object for submission.
      // Set naming convention
      switch (this.options.name_format) {
        case 'master':
          this.choices.name_format = {
            0: '$$master'
          }
          break
        case 'locale':
          this.choices.name_format = {
            0: '$$locale'
          }
          break
        default:
          this.choices.name_format = {
            0: '$$master',
            1: '_',
            2: '$$locale'
          }
          break
      }
      this.choices.zip_creatives = this.options.zip_creatives
      // HTML only options
      if (this.creativeUnitType === 'html') {
        this.choices.statics = this.options.statics
        this.choices.include_html5 = this.options.include_html5
      }
      // PSD only options
      if (this.creativeUnitType === 'psd') {
        this.choices.group_by = this.options.group_by
        var formats = []
        for (var format in this.options.formats) {
          if (this.options.formats[format]) {
            formats.push(format)
          }
        }
        this.choices.export_formats = Object.assign({}, formats)
      }
      this.$emit('onAcceptCharge', this.choices)
      this.close()
    },
    validateHtmlOptions () {
      const {include_html5: includeHtml5, statics} = this.options

      /**
       * If there is no assets selected for HTML units
       * force to have almost the HTML
       */
      setTimeout(() => {
        if (!includeHtml5 && !statics) {
          this.options.include_html5 = true
        }
        this.options.include_html5_inactive = (!includeHtml5 && !statics)
      }, 200)
    }
  }
}

</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/Modal/creatives/modal-charge-confirmation.vue